var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"staticHeader",staticClass:"sticky-header z-30 bg-white relative px-8",class:{ 'sticky top-0 shadow-md': _vm.isSticky }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }